<div class="line">
  <div class="title">
    {{ developmentPageLineParams().title }}
  </div>
  @switch (developmentPageLineParams().type) {
    @case ('link') {
      <div class="link">
        <a
          [href]="developmentPageLineParams().href"
          target="_blank"
        >
          {{ developmentPageLineParams().text }}
        </a>
      </div>
    }
    @case ('button') {
      <div class="info">
        {{ developmentPageLineParams().text }}
      </div>
      <button
        mat-stroked-button
        color="primary"
        (click)="copyToClipboard(developmentPageLineParams().text)"
      >
        {{ developmentPageLineParams().btnText }}
      </button>
    }
    @case ('info') {
      <div class="info">
        {{ developmentPageLineParams().text }}
      </div>
    }
  }
</div>
